export const POLITICA_SIN_RESTRICCION = 'sin_restriccion';

export const POLITICAS_RESTRICCION_PAGO = {
  SOLO_MERCADO_PAGO: 'solo_mercado_pago',
  SOLO_TRANSFERENCIA: 'solo_transferencia',
};

export const OPCIONES_POLITICA_RESTRICCION = [
  {
    value: POLITICA_SIN_RESTRICCION,
    label: 'Sin restricción',
    description: 'Transferencia y Mercado Pago habilitados',
  },
  {
    value: POLITICAS_RESTRICCION_PAGO.SOLO_MERCADO_PAGO,
    label: 'Solo Mercado Pago',
    description: 'Bloquea la carga de comprobantes por transferencia',
  },
  {
    value: POLITICAS_RESTRICCION_PAGO.SOLO_TRANSFERENCIA,
    label: 'Solo transferencia',
    description: 'Bloquea el checkout de Mercado Pago',
  },
];

export function etiquetaPoliticaRestriccion(politica) {
  return OPCIONES_POLITICA_RESTRICCION.find((opcion) => opcion.value === politica)?.label || 'Sin restricción';
}

export function descripcionPoliticaRestriccion(politica) {
  return OPCIONES_POLITICA_RESTRICCION.find((opcion) => opcion.value === politica)?.description || '';
}
